"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DesignInspirationCategory_1 = require("./DesignInspirationCategory");
class DesignInspirationCase {
    constructor({ id, url, name, thumbnailUrl, description, category, }) {
        this.toJSON = () => ({
            id: this.id,
            url: this.url,
            name: this.name,
            thumbnailUrl: this.thumbnailUrl,
            description: this.description,
            category: this.category && this.category.toJSON(),
        });
        this.id = id;
        this.url = url;
        this.name = name;
        this.thumbnailUrl = thumbnailUrl;
        this.description = description;
        this.category = category;
    }
}
DesignInspirationCase.fromJSON = (json) => {
    const { id, url, name, thumbnailUrl, description, category } = Object.assign({}, json);
    if (id !== undefined && typeof id !== 'string')
        throw new Error('.id must be a string');
    if (url !== undefined && typeof url !== 'string')
        throw new Error('.url must be a string');
    if (name !== undefined && typeof name !== 'string')
        throw new Error('.name must be a string');
    if (thumbnailUrl !== undefined && typeof thumbnailUrl !== 'string')
        throw new Error('.thumbnailUrl must be a string');
    if (description !== undefined && typeof description !== 'string')
        throw new Error('.description must be a string');
    const _category = DesignInspirationCategory_1.default.fromJSON(category);
    return new DesignInspirationCase({
        id,
        url,
        name,
        thumbnailUrl,
        description,
        category: _category,
    });
};
exports.default = DesignInspirationCase;
